<template>
  <div>
    <b-row>
      <!-- ค่าเฉลี่ยระดับน้ำ ภายใน 7 วัน -->
      <b-col
        lg="12"
        md="12"
        xs="12"
      >
        <b-col>
          <b-card style="font-size:18px; background-color:rgba(0, 0, 0, 0); width: 100%; color:#ffffff; border: 2px solid #00B058; border-radius: 40px 4px 40px 4px;">

            <div>
              <b-img
                class="mr-1 mb-1"
                height="20"
                src="@/assets/images/icons/bridge/Water.svg"
              />
              <span style="font-size:20px; color: #fff;">ค่าเฉลี่ยระดับน้ำ ภายใน 7 วัน</span>
            </div>

            <div>
              <app-echart-line
                :option-data="option"
              />
            </div>
          </b-card>
        </b-col>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {
  BRow, BCol, BImg, BCard,
} from 'bootstrap-vue'
import axios from '@axios'
import * as echarts from 'echarts'
import AppEchartLine from '@/views/sensor/bridge/detail/garaphLineB/AppEchartLineB.vue'
// import AppEchartBar from '@/views/sensor/bridge/detail/garaphLineB/AppEchartBarCounting.vue'

export default {
  components: {
    BRow,
    BCol,
    BImg,
    BCard,
    AppEchartLine,
    // AppEchartBar,
  },
  data() {
    return {
      option: {
        xAxisData: [],
        series: [
          {
            name: 'ระดับน้ำ(วัน)',
            type: 'line',
            areaStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: '#00C9FF' },
                { offset: 1, color: 'rgba(0, 120, 255, 0.5)' },
              ]),
            },
            color: '#00B6FF',
            showSymbol: true,
            smooth: 0.4,
            lineStyle: {
              width: 0,
            },
            data: [],
          },
          // {
          //   name: 'ระดับน้ำสูงสุด(วัน)',
          //   type: 'line',
          //   areaStyle: {
          //     color: '#00B058',
          //   },
          //   color: '#00B058',
          //   showSymbol: false,
          //   smooth: 0.4,
          //   lineStyle: {
          //     width: 2,
          //   },
          //   data: [],
          // },
        ],
      },

      /* -------------------- กราฟแท่ง --------------------*/
      // option: {
      //   xAxisData: [],
      //   series: [
      //     {
      //       name: 'ทั้งหมด',
      //       type: 'bar',
      //       stack: 'Total',
      //       itemStyle: {
      //         color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
      //           offset: 0,
      //           color: '#99E8FB',
      //         },
      //         {
      //           offset: 1,
      //           color: '#0070B0',
      //         },
      //         ]),
      //         barBorderRadius: [4, 4, 0, 0],
      //       },
      //       data: [],
      //       barMaxWidth: '40%',
      //       barMinWidth: '10px',
      //     },
      //   ],
      // },

      userData: JSON.parse(localStorage.getItem('userData')),
    }
  },
  beforeDestroy() {
    clearInterval(this.interval)
  },
  mounted() {
    this.getbarChartCounting()
    this.interval = setInterval(() => {
      // this.getbarChartCounting()
    }, 300000)
  },
  methods: {
    getbarChartCounting() {
      axios
        .post('/waterLevelGraph7Detail', { wid: this.$route.query.wid })
        .then(response => {
          this.xAxisData = []
          this.xAxisData[0] = response.data
          this.xAxisData[0].forEach(value => {
            this.option.xAxisData.push(value.date_time)
            this.option.series[0].data.push(value.Water_Level)
            // this.option.series[1].data.push(value.Car_Stop)
          })
        })
        .catch(error => {
          console.log(error)
        })
    },
  },
}
</script>

<style lang="scss" scoped>

    .chart{
      top: 0;
      left: 0;
      right: 60px;
    }

.br {
      display: block;
      margin-bottom: 0em;
    }
  </style>
